// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import router from './router'
import axios from 'axios'
import 'lib-flexible'
import MintUI from 'mint-ui'
const Mock = require('mockjs');

import App from './App'
import global from "../src/js/global.js"

Vue.use(MintUI)
import iView from '../node_modules/iview/dist/iview';
import 'iview/dist/styles/iview.css';
import { Indicator } from 'mint-ui';
Vue.use(iView);
axios.defaults.headers.common['Authorization'] = "bearer ";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

import components from './components/' //加载公共组件
Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) //首字母大写
  Vue.component(`v${name}`, components[key])
})
Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL= global.baseHeaderUrl;//头部链接

// 添加响应拦截器
Vue.prototype.$http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if(response.data.dataCode=="0"){
    Indicator.close();
    Vue.$toast(response.data.respMsg);
  }
  if(response.data.dataCode=="2"){//token失效
    if(global.getmobiletype()=="android"){
      control.tokenTimeout()
    }
    else{
      window.webkit.messageHandlers.loginForInvalidToken.postMessage("");
      return false;
    }
    return;     
  }
  response = response.data
  //Mock.mock(response.data)
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.config.productionTip = false
/* eslint-disable no-new */
import "./style/base.less"
import "./style/mint.less"
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js